import { formatExpiresAt } from '@modules/Dashboard/modules/PaymentMethods/utils/formatExpiresAt';
export const mapUserPaymentMethods = (paymentMethods) => paymentMethods.map((paymentMethod, index) => {
    if (paymentMethod.details.type === 'CARD') {
        return {
            id: paymentMethod.id,
            type: 'CARD',
            brand: paymentMethod.details.brand,
            number: paymentMethod.details.last4Digits,
            expires: formatExpiresAt(paymentMethod.details.expiresAt),
            selected: index === 0,
        };
    }
    // PAYPAL
    return {
        id: paymentMethod.id,
        type: 'PAYPAL',
        email: paymentMethod.details.email,
        selected: index === 0,
    };
});
